import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-main">
          <div className="footer-brand">
            <div className="footer-brand-row">
              <img
                src="/images/hs-logo-square.png"
                alt="株式会社エイチエス"
                className="footer-mark"
              />
              <div>
                <p className="footer-brand-label">HS CO., LTD.</p>
                <h3 className="footer-logo">株式会社エイチエス</h3>
              </div>
            </div>

            <p className="footer-description">
              看板・LED照明・LEDビジョン・防犯カメラ・パーキングシステムなど、
              現場に必要な設備を一つひとつ丁寧にご提案します。
            </p>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">PRODUCTS</h4>
            <ul className="footer-links">
              <li><Link to="/products/signage">看板・サイン</Link></li>
              <li><Link to="/products/led-lighting">LED照明</Link></li>
              <li><Link to="/products/led-vision">LEDビジョン</Link></li>
              <li><Link to="/products/electric-board">電光掲示板</Link></li>
              <li><Link to="/products/security-camera">防犯カメラ</Link></li>
              <li><Link to="/products/parking-system">パーキングシステム</Link></li>
              <li><Link to="/products/emergency-board">緊急出動警報板</Link></li>
              <li><Link to="/products/custom-metal">カスタム金物製作</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">COMPANY</h4>
            <ul className="footer-links">
              <li><Link to="/company">会社概要</Link></li>
              <li><Link to="/company#licenses">許認可・登録</Link></li>
              <li><Link to="/construction-support">施工・サポート</Link></li>
              <li><Link to="/contact">お問い合わせ</Link></li>
            </ul>
          </div>

          <div className="footer-section footer-contact">
            <h4 className="footer-title">CONTACT</h4>
            <p className="footer-contact-line">TEL：03-6825-0852</p>
            <p className="footer-contact-line">FAX：050-6868-2670</p>
            <p className="footer-contact-line">MAIL：kim@hs-i.co.jp</p>

            <Link to="/contact" className="footer-contact-button">
              お問い合わせ
              <span>→</span>
            </Link>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© 2025 株式会社エイチエス. All Rights Reserved.</p>

          <button
            type="button"
            className="footer-top-button"
            onClick={scrollToTop}
            aria-label="ページ上部へ戻る"
          >
            ↑
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;